import buildTemplate from '../views/partials/build.html';

export function build() {
  return {
    template: buildTemplate,
  }
}
